import { DataReducerType, LinkPopulationPair, LinkPackagePair, LinkPackageObj } from "./types";
import { key } from "../utils";

export const addAssignments = (payload: LinkPackagePair[] = [], state: DataReducerType) => {
  const neaAssignments = {
    ...state?.assignments,
  };

  payload.forEach(({ package: pkg, linkId }) => {
    const objKey = key(pkg?.id, linkId);

    neaAssignments[objKey] = {
      linkId,
      package: pkg,
    };
  });

  return {
    ...state,
    assignments: neaAssignments,
  };
};

export const addAssignment = (
  { package: pack, linkId }: LinkPackagePair,
  state: DataReducerType,
): DataReducerType => ({
  ...state,
  assignments: {
    ...(state?.assignments ?? {}),
    [key(pack?.id, linkId)]: { package: pack, linkId },
  },
});

export const addCreation = (
  { population, linkId, termId, packageName }: LinkPopulationPair,
  state: DataReducerType,
): DataReducerType => ({
  ...state,
  creations: {
    ...(state?.creations ?? {}),
    [!linkId ? population?.code : key(population?.code, linkId)]: {
      population,
      linkId,
      termId,
      packageName,
    },
  },
});

export const addDeletion = (
  { package: pack, linkId }: LinkPackagePair,
  state: DataReducerType,
): DataReducerType => ({
  ...state,
  deletions: {
    ...(state?.deletions ?? {}),
    [key(pack?.id, linkId)]: { package: pack, linkId },
  },
});

export const cleanAssignments = (state: DataReducerType): DataReducerType => ({
  ...state,
  assignments: {},
});

export const cleanCreations = (state: DataReducerType): DataReducerType => ({
  ...state,
  creations: {},
});

export const cleanDeletions = (state: DataReducerType): DataReducerType => ({
  ...state,
  deletions: {},
});

export const deleteAssignment = (
  { package: { id: packageId }, linkId }: LinkPackagePair,
  state: DataReducerType,
): DataReducerType => ({
  ...state,
  assignments: Object.fromEntries(
    Object.entries(state?.assignments ?? {}).filter(
      ([, pair]) => pair?.package?.id !== packageId || pair?.linkId !== linkId,
    ),
  ),
});

export const deleteAssignments = (payload: LinkPackageObj, state: DataReducerType) => {
  return {
    ...state,
    assignments: payload,
  };
};

export const deleteCreation = (
  { population: { code }, linkId }: LinkPopulationPair,
  state: DataReducerType,
): DataReducerType => ({
  ...state,
  creations: Object.fromEntries(
    Object.entries(state?.creations ?? {}).filter(
      ([, pair]) => pair?.population?.code !== code || pair?.linkId !== linkId,
    ),
  ),
});

export const setLink = (
  link: DataReducerType["link"],
  state: DataReducerType,
): DataReducerType => ({
  ...state,
  link,
});

export const setPopulations = (
  populations: DataReducerType["populations"],
  state: DataReducerType,
): DataReducerType => ({ ...state, populations });
